import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import useUserData from 'hooks/useUserData';
import { updateResourceOnboarded } from 'services/user';
import { setUserData } from 'store/reducers/user-reducer';

import { ResourceDetailContext } from '../ResourceDetail/ResourceDetailContext';

interface ResourceOnboardingSequenceValues {
  showOnboarding: boolean;
  setShowOnboarding: (value: boolean) => void;
  currentStep: number;
  nextStep: () => void;
  close: () => void;
  hideLastStep: boolean;
}

export default function useResourceOnboardingSequence(): ResourceOnboardingSequenceValues {
  const userData = useUserData();
  const dispatch = useDispatch();
  const { onboardingStep, setOnboardingStep, hideLastStep } = useContext(ResourceDetailContext);
  const [showOnboarding, setShowOnboarding] = useState(userData?.resource_onboarding);

  const handleNextStep = () => {
    setOnboardingStep(onboardingStep + 1);
  };

  useEffect(() => {
    if (onboardingStep > 3) {
      updateResourceOnboarded({ status: false });
      dispatch(setUserData({ ...userData, resource_onboarding: false }));
    }
  }, [onboardingStep]);

  const handleClose = () => {
    updateResourceOnboarded({ status: false });
    dispatch(setUserData({ ...userData, resource_onboarding: false }));
  };

  return {
    showOnboarding: userData?.resource_onboarding,
    setShowOnboarding,
    currentStep: onboardingStep,
    nextStep: handleNextStep,
    close: handleClose,
    hideLastStep,
  };
}
